class RelatedProgramsSlider {
    constructor() {
        Object.defineProperty(this, "wrapper", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "slickSlider", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "windowWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "sliderWidth", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "prevArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "nextArrow", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.wrapper = document.querySelector('.container-slider');
        this.slider = this.wrapper ? this.wrapper.querySelector('.block-related-programs__slider') : null;
        this.prevArrow = this.wrapper ? this.wrapper.querySelector('.slick-slider-arrow-prev') : null;
        this.nextArrow = this.wrapper ? this.wrapper.querySelector('.slick-slider-arrow-next') : null;
        this.windowWidth = window.innerWidth;
        this.sliderWidth = 0;
    }
    init() {
        if (!this.slider || !this.wrapper) {
            return;
        }
        const slides = this.slider.querySelectorAll('.program-card');
        for (const slide of slides) {
            this.sliderWidth += slide.clientWidth;
        }
        if (this.windowWidth > this.sliderWidth) {
            this.slider.classList.add('center');
            this.wrapper.classList.add('center');
        }
        else {
            this.initSlider();
        }
        this.addOverlay();
    }
    initSlider() {
        if (!this.slider || this.slickSlider) {
            return;
        }
        this.slickSlider = jQuery(this.slider).slick({
            dots: false,
            prevArrow: this.prevArrow ?? undefined,
            nextArrow: this.nextArrow ?? undefined,
            lazyLoad: 'progressive',
            variableWidth: true,
            infinite: false,
            rows: 0,
        });
        this.slickSlider.slick('slickSetOption', 'outerEdgeLimit', true);
        this.slickSlider.on('afterChange', () => {
            setTimeout(() => {
                this.addOverlay();
            }, 0);
        });
    }
    addOverlay() {
        if (!this.wrapper) {
            return;
        }
        if (this.prevArrow?.classList.contains('slick-disabled')) {
            this.wrapper.classList.remove('arrow-prev-overlay');
        }
        else {
            this.wrapper.classList.add('arrow-prev-overlay');
        }
        if (this.nextArrow?.classList.contains('slick-disabled')) {
            this.wrapper.classList.remove('arrow-next-overlay');
        }
        else {
            this.wrapper.classList.add('arrow-next-overlay');
        }
    }
    destroySlider() {
        this.slickSlider?.slick('unslick');
        this.slickSlider = undefined;
    }
    resized() {
        if (!this.wrapper || !this.slider) {
            return;
        }
        const windowWidth = window.innerWidth;
        if (windowWidth > this.sliderWidth) {
            this.slider.classList.add('center');
            this.wrapper.classList.add('center');
            this.destroySlider();
        }
        else {
            this.slider.classList.remove('center');
            this.wrapper.classList.remove('center');
            this.initSlider();
            this.addOverlay();
        }
    }
}
export default new RelatedProgramsSlider();
